(function() {
    'use strict';
    angular
        .module('emarket.store.post')
        .controller('StorePostController', ['$stateParams', '$sce', '$scope', 'Post', 'Profile', 'profile', 'SellerFactory', 'categories', function($stateParams,
            $sce,
            $scope,
            Post,
            Profile,
            profile,
            SellerFactory,
            categories) {
            var vm = this;
            var Seller = SellerFactory.create($scope);
            Post.$find($stateParams.title)
                .$asPromise()
                .then(function(post) {
                    post.content = $sce.trustAsHtml(post.content);
                    vm.post = post;
                    return Profile.getRelatedProducts(profile._id, post._id, 5);
                })
                .then(function(posts) {
                    vm.related = posts;
                });
            vm.showContactDialog = function($ev) {
                Seller.showContact($ev, vm.post.owner, true);
            };
            vm.categories = categories;

            // vm.post = post;
            // vm.post.content = $sce.trustAsHtml(post.content);
            // var Seller = SellerFactory.create($scope);
            // vm.currentImage = post.images[0];
            // vm.setCurrentImage = function (image) {
            //     vm.currentImage = image;
            // };
            //
            // vm.products = Post.$search({
            //     owner: store._id,
            //     $limit: 10
            // });
            // vm.contact = function () {
            //     Seller.showContact(vm.post.owner);
            // };
        }]);
}());
